var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Multivariate Dependencies
import { css } from 'styled-components';
export var getBorderStylesByState = function (theme, state) {
    var borderStyle = theme.borderSecondary;
    if (state === 'error') {
        borderStyle = theme.borderNegative;
    }
    if (state === 'disabled') {
        borderStyle = theme.disabledSecondary;
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: 1px solid ", ";\n  "], ["\n    border: 1px solid ", ";\n  "])), borderStyle);
};
var templateObject_1;
//# sourceMappingURL=getBorderStylesByState.js.map